/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_No_Scenarios_DetectedInputs */

const en_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const de_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const fr_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const es_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const it_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const nl_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const pl_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const fi_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const da_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

const sv_negotiation_no_scenarios_detected = /** @type {(inputs: Negotiation_No_Scenarios_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No specific negotiation scenarios detected for this job.`)
};

/**
* | output |
* | --- |
* | "No specific negotiation scenarios detected for this job." |
*
* @param {Negotiation_No_Scenarios_DetectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_no_scenarios_detected = /** @type {((inputs?: Negotiation_No_Scenarios_DetectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_No_Scenarios_DetectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_no_scenarios_detected(inputs)
	if (locale === "fr") return fr_negotiation_no_scenarios_detected(inputs)
	if (locale === "es") return es_negotiation_no_scenarios_detected(inputs)
	if (locale === "it") return it_negotiation_no_scenarios_detected(inputs)
	if (locale === "nl") return nl_negotiation_no_scenarios_detected(inputs)
	if (locale === "pl") return pl_negotiation_no_scenarios_detected(inputs)
	if (locale === "fi") return fi_negotiation_no_scenarios_detected(inputs)
	if (locale === "da") return da_negotiation_no_scenarios_detected(inputs)
	if (locale === "sv") return sv_negotiation_no_scenarios_detected(inputs)
	return en_negotiation_no_scenarios_detected(inputs)
});